
import apiWorker from '../apiWorker'

const case_workflow_history = {

    findByCase: (case_id) => apiWorker('get',  `/api/v1/core/case_workflow_history/case/${case_id}`),

}

export default case_workflow_history